import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { DataAction, EmptyAction, MessageAction } from 'src/CustomTypes'
import { HydroModel, HydroModelObject } from 'src/dataSources/geo/HydroModel'
import { RootState } from 'src/Store'

export const FETCHING_HYDRO_MODELS_STARTED =
  'HYDRO_MODELS_ACTIONS_FETCHING_HYDRO_MODELS_STARTED'
export const FETCHING_HYDRO_MODELS_SUCCESS =
  'HYDRO_MODELS_ACTIONS_FETCHING_HYDRO_MODELS_SUCCESS'
export const FETCHING_HYDRO_MODELS_FAILURE =
  'HYDRO_MODELS_ACTIONS_FETCHING_HYDRO_MODELS_FAILURE'

interface HydroModelActions {
  fetchingHydroModelsStarted: () => EmptyAction
  fetchingHydroModelsFailure: (message: string) => MessageAction
  fetchingHydroModelsSuccess: (profile: HydroModelObject[]) => DataAction<HydroModelObject[]>

  // Thunk actions
  fetchHydroModels: () => ThunkAction<Promise<void>, RootState, {}, AnyAction>
}

export const hydroModelActions: HydroModelActions = {
  fetchingHydroModelsStarted: (): EmptyAction => {
    return {
      type: FETCHING_HYDRO_MODELS_STARTED
    }
  },
  fetchingHydroModelsFailure: (message: string): MessageAction => {
    return {
      type: FETCHING_HYDRO_MODELS_FAILURE,
      message: message
    }
  },
  fetchingHydroModelsSuccess: (hydroModels: HydroModelObject[]): DataAction<HydroModelObject[]> => {
    return {
      type: FETCHING_HYDRO_MODELS_SUCCESS,
      data: hydroModels
    }
  },
  fetchHydroModels: (): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState: () => RootState): Promise<void> => {
      // Fetch hydro models
      const token = getState().authState.token
      dispatch(hydroModelActions.fetchingHydroModelsStarted())

      const wsHydroModel = new HydroModel(token)
      try {
        let hydroModels = await wsHydroModel.fetchHydroModels()

        // Sort hydromodels alphabetically
        hydroModels = hydroModels.sort((a, b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))
        dispatch(hydroModelActions.fetchingHydroModelsSuccess(hydroModels))
      } catch (err) {
        console.error(err)
        const errorMessage: string = (err as Error).message
        dispatch(hydroModelActions.fetchingHydroModelsFailure(errorMessage))
      }
    }
  }
}
